module.exports = __webpack_public_path__ + "static/media/lintu.bb616102.png";